export enum EDistanceId {
  pickup = 'pickup',
  dropoff = 'dropoff',
}
